/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Footnote_BuildInputs */

const en_admin_funnel_footnote_build = /** @type {(inputs: Admin_Funnel_Footnote_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build = git commit of the page/server that sent the event.`)
};

/**
* | output |
* | --- |
* | "Build = git commit of the page/server that sent the event." |
*
* @param {Admin_Funnel_Footnote_BuildInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_footnote_build = /** @type {((inputs?: Admin_Funnel_Footnote_BuildInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Footnote_BuildInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_footnote_build(inputs)
});
export { admin_funnel_footnote_build as "admin.funnel.footnote.build" }